export const LOAD_MODEL_YEAR_SUCCESS = 'LOAD_MODEL_YEAR_SUCCESS';
export const CHANGE_BUILD_AND_QUOTE_SECTION = 'CHANGE_BUILD_AND_QUOTE_SECTION';

export const SET_MODEL_YEARS = 'SET_MODEL_YEARS';
export const SET_MODEL_TRIMS = 'SET_MODEL_TRIMS';
export const SET_DRIVE_POWER_TRAINS = 'SET_DRIVE_POWER_TRAINS';
export const SET_OPTIONS_PACKAGES = 'SET_OPTIONS_PACKAGES';

export default {
    LOAD_MODEL_YEAR_SUCCESS,
    SET_MODEL_YEARS,
    SET_MODEL_TRIMS,
    SET_DRIVE_POWER_TRAINS,
    SET_OPTIONS_PACKAGES,
    CHANGE_BUILD_AND_QUOTE_SECTION,
};



// WEBPACK FOOTER //
// ../widget-commons-vehicle/src/ModelYear/actions/modelYearActionTypes.js